import Vue from 'vue'

export default function() {
  const store = Vue.observable({
    cuils: []
  })

  const setCuils = cuils => (store.cuils = cuils)

  return {
    store,
    setCuils
  }
}
